import { MANAGEMENT_ROUTE } from "app/pages/sales-intelligence/constants/routes";
import {
    MANAGEMENT_APIS_AND_WEBHOOKS_ROUTE,
    MANAGEMENT_CRM_INTEGRATIONS_ROUTE,
} from "app/pages/sales-intelligence/constants/sl_routes";
import {
    MANAGEMENT_APIS_AND_WEBHOOKS,
    MANAGEMENT_CRMS_AND_CONNECTORS,
    MANAGEMENT_MY_INTEGRATIONS,
} from "app/pages/sales-intelligence/pages/management/translations/managementKeys";

export const GATEWAY_BREADCRUMB_PARENT = {
    default: {
        route: MANAGEMENT_ROUTE,
        titleKey: MANAGEMENT_MY_INTEGRATIONS,
    },
    apisAndWebhooks: {
        route: MANAGEMENT_APIS_AND_WEBHOOKS_ROUTE,
        titleKey: MANAGEMENT_APIS_AND_WEBHOOKS,
    },
    crmIntegrations: {
        route: MANAGEMENT_CRM_INTEGRATIONS_ROUTE,
        titleKey: MANAGEMENT_CRMS_AND_CONNECTORS,
    },
} as const;
